/**
 * Timer-driven drain wake. `online` / `pageshow` / `visibilitychange` are the fast path, but none of
 * them is guaranteed to fire (a radio that never dropped, a stuck `navigator.onLine`, a foreground
 * tab nobody touches), so every drain host also polls. contact-admin has done this since LSP-16994;
 * this is the same idea for hosts built on the shared drain engine.
 */
export const UPLOAD_DRAIN_POLL_INTERVAL_MS = 30_000;

/** Start polling; returns the stop function. */
export function startPeriodicWake(wake: (reason: "poll") => void, intervalMs = UPLOAD_DRAIN_POLL_INTERVAL_MS): () => void {
	const timer = globalThis.setInterval(() => wake("poll"), intervalMs);
	return () => globalThis.clearInterval(timer);
}
